<template>
                  <div class="p-2">
  <div class="card" style="width: 100%;">
  <!--<img class="card-img-top" data-src=".../100px180/" alt="Card image cap"> -->
  <div class="card-body">
    <h4 class="card-title">Solutions</h4>
    <p class="card-text"></p>
                <ul class="list-unstyled p-2 card-text">
                  <li class="p-1">
                    <router-link to="/solutions/digitalinfrastructure" >Data Centers</router-link>
                  </li>
                  <li class="p-1">
                    <router-link to="/solutions/digitalinfrastructure/networking">Networking</router-link>
                  </li>
                  <li class="p-1">
                    <router-link to="/solutions/digitalinfrastructure/collaboration">Collaboration</router-link>
                  </li>

                   <li class="p-1">
                    <router-link to="/solutions/digitalinfrastructure/analytics">Analytics</router-link>
                  </li>
                </ul>
  </div>
</div>
              </div>
</template>

<script>
export default {
    name :'digitalInfrasidenav',
     mounted: function()
  {
    // From testing, without a brief timeout, it won't work.
    setTimeout(
      () => 
      {this.scrollFix(this.$route.hash) 
    
    }
    , 1);

  },
  methods: {
    scrollFix: function(hashbang)
    {
      location.hash = hashbang ;
    }
  }
}
</script>